<template>
  <div>
    <monthly-report-download
      mode="operator" />
    <analytics-select
      mode="operator" />
  </div>
</template>

<script>
import AnalyticsSelect from '@/views/pages/Common/Analytics/AnalyticsSelect.vue';
import MonthlyReportDownload from '@/views/pages/Common/Analytics/MonthlyReportDownload.vue';

export default {
  name: 'operatorAnalytics',
  components: {
    AnalyticsSelect,
    MonthlyReportDownload,
  },
};
</script>
